import { render, staticRenderFns } from "./newMsdsList.vue?vue&type=template&id=070e9e59&scoped=true"
import script from "./newMsdsList.vue?vue&type=script&lang=js"
export * from "./newMsdsList.vue?vue&type=script&lang=js"
import style0 from "./newMsdsList.vue?vue&type=style&index=0&id=070e9e59&lang=css"
import style1 from "./newMsdsList.vue?vue&type=style&index=1&id=070e9e59&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e9e59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070e9e59')) {
      api.createRecord('070e9e59', component.options)
    } else {
      api.reload('070e9e59', component.options)
    }
    module.hot.accept("./newMsdsList.vue?vue&type=template&id=070e9e59&scoped=true", function () {
      api.rerender('070e9e59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msds/newMsds/newMsdsList.vue"
export default component.exports